import React from "react";
import PropTypes from "prop-types";
import { isValidValue } from "utils/validators";

export const ViewedCellFormatter = ({ value }) => {
  if (!isValidValue(value)) {
    return <span />;
  }
  return <div> {value ? "Yes" : "No"} </div>;
};

ViewedCellFormatter.propTypes = {
  value: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/grid/cell-formatters/viewed-cell-formatter.jsx